import {BaseAnalyticsEvent} from "./base-analytics-event";

export class WidgetsAnalyticsEvent extends BaseAnalyticsEvent {
  widgetId: String;

  constructor(params, label) {
    super('', label, 'widget');

    this.widgetId = params.widgetId;
  }

  get properties() {
    const properties = super.properties;

    properties.widgetId = this.widgetId;

    return properties;
  }
}